//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { Box, Button, Flex, HStack, Text } from "@chakra-ui/react";
import React from "react";
import { displayToast } from "../../src/tutor-revamp/forms/SharedComponents";
import RemarkApp from "./Remark";

const styles = {
  parent: {
    marginBottom: 20,
  },
  FormGroup: {
    marginBottom: 10,
  },
  label: {
    marginRight: 10,
    marginBottom: 10,
    width: "15%",
    display: "inline-block",
  },
  input: {
    width: "70%",
  },
};

const stages = [
  { value: 1, label: "New Follow-up" },
  { value: 2, label: "First Contact - Day 0" },
  { value: 3, label: "Second Contact - Day 1" },
  { value: 4, label: "Third Contact - Day 2" },
  { value: 5, label: "Fourth Contact - Day 4" },
  { value: 6, label: "Firth Contact - Day 7" },
  { value: 7, label: "Sixth Contact - Day 10" },
  { value: 8, label: "Seventh Contact - Day 14" },
  { value: 9, label: "Eight Contact - Day - 19" },
  { value: 10, label: "Ninth Contact - Day - 24" },
  { value: 11, label: "Tenth Contact - Day 30" },
];

function getNextStage(currentStage) {
  let index = stages.findIndex((o) => o.value === parseInt(currentStage));
  if (index < 10) {
    return stages[index + 1];
  }
}
const FormGroup = ({ label, children }) => (
  <Flex my={5}>
    <label style={styles.label}>{label}</label>
    {children}
  </Flex>
);

type Props = {
  request_id: string;
  content?: string;
  onUpdateRemark: (...args: any[]) => Promise<any>;
  actions: any[];
  onUpdateStage: (...args: any[]) => Promise<any>;
  currentStage?: number;
  removeRow?: any;
  updateRemarkCell?: any;
};

export default function RequestFollowUp({
  request_id,
  onUpdateRemark,
  actions = [],
  onUpdateStage,
  content = "",
  removeRow = () => {},
  updateRemarkCell = () => [],
  currentStage,
}: Props) {
  const [followUpStage, setFollowUpStage] = React.useState(currentStage);
  const [isStageLoading, setStageLoading] = React.useState(false);
  const currentLabel = stages.find((o) => o.value == currentStage);
  let nextStage = getNextStage(followUpStage);
  return (
    <RemarkApp
      content={content}
      setDefaultRemark={false}
      request_id={request_id}
      actions={actions}
      onUpdateRemark={onUpdateRemark}
      afterAction={updateRemarkCell}
      displayContent={false}
    >
      <HStack justifyContent={"space-between"}>
        <Text>
          <strong>Current Stage:</strong> {currentLabel.label}
        </Text>
        <Box>
          {nextStage ? (
            <Button
              isLoading={isStageLoading}
              loadingText="Saving stage"
              onClick={(e) => {
                setStageLoading(true);
                onUpdateStage(request_id, nextStage.value)
                  .then((result) => {
                    setStageLoading(false);
                    displayToast({
                      description: "Updated stage",
                      status: "success",
                      title: "Stage updated",
                    });
                    if (removeRow) {
                      removeRow();
                    }
                  })
                  .catch((error) => {
                    displayToast({
                      description: "Error from server",
                      status: "error",
                      title: "Error",
                    });
                  });
              }}
              colorScheme={"blue"}
            >
              Update to {nextStage.label}
            </Button>
          ) : (
            <Button colorScheme={"blue"} isDisabled>
              Last Stage
            </Button>
          )}
        </Box>
      </HStack>
    </RemarkApp>
  );
  // return <EditContainer isOpen onClose={onClose}></EditContainer>;
}
